// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  color: #253750;
  font-size: 12px;
}

.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 4px 24px 18px;
  border-bottom: 1px solid #edf1f6;
}

.dialog-header h2 {
  margin: 0;
  padding: 0;
  font-size: 17px;
  font-weight: 600;
  line-height: 24px;
}

.dialog-header p {
  margin: 5px 0 0;
  color: #7d8a9d;
  font-size: 12px;
  line-height: 18px;
}

.icon-button {
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #7d8a9d;
  cursor: pointer;
}

.icon-button:hover:not(:disabled) {
  background: color-mix(in srgb, var(--primary-color) 6%, white);
  color: var(--primary-color);
}

.icon-button:disabled {
  opacity: 0.45;
}

.icon-button span {
  font-size: 20px;
}

.dialog-content {
  margin: 0;
  padding: 20px 24px;
  max-height: 65vh;
}

.search-field {
  position: relative;
  margin-bottom: 10px;
}

.search-field > span {
  position: absolute;
  inset-inline-start: 10px;
  top: 9px;
  color: #8a98ab;
  font-size: 17px;
}

.search-field input,
.commission-field input {
  width: 100%;
  height: 36px;
  box-sizing: border-box;
  border: 1px solid #dce5ef;
  border-radius: 7px;
  padding: 0 10px;
  color: #253750;
  font: inherit;
  font-size: 11px;
}

.search-field input {
  padding-inline-start: 33px;
}

.search-field input:focus,
.commission-field input:focus {
  outline: none;
  border-color: var(--primary-color);
}

.selection-note {
  margin: 0 0 10px;
  color: #7d8a9d;
  font-size: 11px;
}

.table-scroll {
  max-height: 260px;
  overflow: auto;
  border: 1px solid #edf1f6;
  border-radius: 8px;
}

table {
  width: 100%;
  border-collapse: collapse;
  text-align: start;
  font-size: 11px;
}

th {
  padding: 10px 12px;
  background: #fbfcfe;
  color: #7d8a9d;
  font-size: 10px;
  font-weight: 500;
  white-space: nowrap;
  text-align: start;
}

td {
  padding: 9px 12px;
  border-top: 1px solid #edf1f6;
  color: #53647a;
}

.product-id {
  color: var(--primary-color);
  font-weight: 500;
}

.product-image {
  width: 30px;
  height: 30px;
  object-fit: contain;
  border: 1px solid #edf1f6;
  border-radius: 6px;
}

.name-cell {
  max-width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.edit-product {
  margin: 0 0 18px;
  padding: 10px 12px;
  border-radius: 7px;
  background: #f7f9fc;
  color: #53647a;
}

.edit-product span {
  margin-inline-end: 7px;
  color: #7d8a9d;
  font-size: 10px;
  text-transform: uppercase;
}

.schedule-form {
  margin-top: 20px;
}

.date-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.field label {
  display: block;
  margin-bottom: 7px;
  color: #35445b;
  font-size: 12px;
  font-weight: 500;
}

.field mat-form-field {
  width: 100%;
  font-size: 11px;
  --mat-form-field-container-height: 38px;
  --mat-form-field-container-vertical-padding: 9px;
  --mdc-outlined-text-field-outline-color: #dce5ef;
  --mdc-outlined-text-field-focus-outline-color: var(--primary-color) ;
}

.commission-field {
  max-width: 260px;
  margin-top: 16px;
}

.error {
  margin: 4px 0 0;
  color: #c34242;
  font-size: 11px;
}

.saving {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 16px;
  color: #7d8a9d;
  font-size: 11px;
}

.dialog-footer {
  min-height: 0;
  margin: 0;
  padding: 16px 24px;
  border-top: 1px solid #edf1f6;
}

.button {
  min-height: 34px;
  border: 1px solid #dce5ef;
  border-radius: 7px;
  padding: 7px 14px;
  background: #fff;
  color: #53647a;
  font: inherit;
  font-size: 12px;
  cursor: pointer;
}

.button.primary {
  border-color: var(--primary-color);
  background: var(--primary-color);
  color: #fff;
}

.button:disabled {
  opacity: 0.45;
  cursor: default;
}

@media (max-width: 550px) {
  .dialog-header,
  .dialog-content,
  .dialog-footer {
    padding-inline: 16px;
  }
  .date-fields {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/add-featured-product/add-featured-product.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,sBAAA;EACA,gCAAA;AACJ;;AAEA;EACI,SAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,eAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,8DAAA;EACA,2BAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,SAAA;EACA,kBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,wBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AACJ;;AAEA;;EAEI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;AACJ;;AAEA;EACI,0BAAA;AACJ;;AAEA;;EAEI,aAAA;EACA,kCAAA;AACJ;;AAEA;EACI,gBAAA;EACA,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AACJ;;AAEA;EACI,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,6BAAA;EACA,cAAA;AACJ;;AAEA;EACI,2BAAA;EACA,gBAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AACJ;;AAEA;EACI,sBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,SAAA;AACJ;;AAEA;EACI,cAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACJ;;AAEA;EACI,WAAA;EACA,eAAA;EACA,uCAAA;EACA,gDAAA;EACA,gDAAA;EACA,oEAAA;AACJ;;AAEA;EACI,gBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,eAAA;EACA,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;AACJ;;AAEA;EACI,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;AACJ;;AAEA;EACI,kCAAA;EACA,gCAAA;EACA,WAAA;AACJ;;AAEA;EACI,aAAA;EACA,eAAA;AACJ;;AAEA;EAEI;;;IAGI,oBAAA;EAAN;EAGE;IACI,0BAAA;EADN;AACF","sourcesContent":[":host {\n    display: block;\n    color: #253750;\n    font-size: 12px\n}\n\n.dialog-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 4px 24px 18px;\n    border-bottom: 1px solid #edf1f6\n}\n\n.dialog-header h2 {\n    margin: 0;\n    padding: 0;\n    font-size: 17px;\n    font-weight: 600;\n    line-height: 24px\n}\n\n.dialog-header p {\n    margin: 5px 0 0;\n    color: #7d8a9d;\n    font-size: 12px;\n    line-height: 18px\n}\n\n.icon-button {\n    display: grid;\n    place-items: center;\n    width: 28px;\n    height: 28px;\n    border: 0;\n    border-radius: 7px;\n    background: transparent;\n    color: #7d8a9d;\n    cursor: pointer\n}\n\n.icon-button:hover:not(:disabled) {\n    background: color-mix(in srgb, var(--primary-color) 6%, white);\n    color: var(--primary-color)\n}\n\n.icon-button:disabled {\n    opacity: .45\n}\n\n.icon-button span {\n    font-size: 20px\n}\n\n.dialog-content {\n    margin: 0;\n    padding: 20px 24px;\n    max-height: 65vh\n}\n\n.search-field {\n    position: relative;\n    margin-bottom: 10px\n}\n\n.search-field>span {\n    position: absolute;\n    inset-inline-start: 10px;\n    top: 9px;\n    color: #8a98ab;\n    font-size: 17px\n}\n\n.search-field input,\n.commission-field input {\n    width: 100%;\n    height: 36px;\n    box-sizing: border-box;\n    border: 1px solid #dce5ef;\n    border-radius: 7px;\n    padding: 0 10px;\n    color: #253750;\n    font: inherit;\n    font-size: 11px\n}\n\n.search-field input {\n    padding-inline-start: 33px\n}\n\n.search-field input:focus,\n.commission-field input:focus {\n    outline: none;\n    border-color: var(--primary-color)\n}\n\n.selection-note {\n    margin: 0 0 10px;\n    color: #7d8a9d;\n    font-size: 11px\n}\n\n.table-scroll {\n    max-height: 260px;\n    overflow: auto;\n    border: 1px solid #edf1f6;\n    border-radius: 8px\n}\n\ntable {\n    width: 100%;\n    border-collapse: collapse;\n    text-align: start;\n    font-size: 11px\n}\n\nth {\n    padding: 10px 12px;\n    background: #fbfcfe;\n    color: #7d8a9d;\n    font-size: 10px;\n    font-weight: 500;\n    white-space: nowrap;\n    text-align: start\n}\n\ntd {\n    padding: 9px 12px;\n    border-top: 1px solid #edf1f6;\n    color: #53647a\n}\n\n.product-id {\n    color: var(--primary-color);\n    font-weight: 500\n}\n\n.product-image {\n    width: 30px;\n    height: 30px;\n    object-fit: contain;\n    border: 1px solid #edf1f6;\n    border-radius: 6px\n}\n\n.name-cell {\n    max-width: 170px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap\n}\n\n.edit-product {\n    margin: 0 0 18px;\n    padding: 10px 12px;\n    border-radius: 7px;\n    background: #f7f9fc;\n    color: #53647a\n}\n\n.edit-product span {\n    margin-inline-end: 7px;\n    color: #7d8a9d;\n    font-size: 10px;\n    text-transform: uppercase\n}\n\n.schedule-form {\n    margin-top: 20px\n}\n\n.date-fields {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 14px\n}\n\n.field label {\n    display: block;\n    margin-bottom: 7px;\n    color: #35445b;\n    font-size: 12px;\n    font-weight: 500\n}\n\n.field mat-form-field {\n    width: 100%;\n    font-size: 11px;\n    --mat-form-field-container-height: 38px;\n    --mat-form-field-container-vertical-padding: 9px;\n    --mdc-outlined-text-field-outline-color: #dce5ef;\n    --mdc-outlined-text-field-focus-outline-color: var(--primary-color)\n}\n\n.commission-field {\n    max-width: 260px;\n    margin-top: 16px\n}\n\n.error {\n    margin: 4px 0 0;\n    color: #c34242;\n    font-size: 11px\n}\n\n.saving {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    margin-top: 16px;\n    color: #7d8a9d;\n    font-size: 11px\n}\n\n.dialog-footer {\n    min-height: 0;\n    margin: 0;\n    padding: 16px 24px;\n    border-top: 1px solid #edf1f6\n}\n\n.button {\n    min-height: 34px;\n    border: 1px solid #dce5ef;\n    border-radius: 7px;\n    padding: 7px 14px;\n    background: #fff;\n    color: #53647a;\n    font: inherit;\n    font-size: 12px;\n    cursor: pointer\n}\n\n.button.primary {\n    border-color: var(--primary-color);\n    background: var(--primary-color);\n    color: #fff\n}\n\n.button:disabled {\n    opacity: .45;\n    cursor: default\n}\n\n@media(max-width:550px) {\n\n    .dialog-header,\n    .dialog-content,\n    .dialog-footer {\n        padding-inline: 16px\n    }\n\n    .date-fields {\n        grid-template-columns: 1fr\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
